import { createSlice } from '@reduxjs/toolkit'

export const linkSlice = createSlice({
  name: 'link',
  initialState: {
    title: 'Teknikforce',
    files: [],
    description: 'Generate fully customized QR Codes',
    multipleLinks: [
      { title: 'Facebook', link: 'https://facebook.com/' },
      { title: 'Instagram', link: 'https://instagram.com/' },
      { title: 'Website', link: 'https://qroq.in' }
    ],
    fontFamily: 'Arial, sans-serif',
    cardColor: '#ffffff',
    titleColor: '#ffffff',
    titleBackgroundColor: '#1e2746',
    descriptionColor: '#000000',
    linkTitleColor: '#000000',
    linkButtonBackgroundColor: '#f2f2f2',
    linkButtonBorderColor: '#000000',
    linkButtonHoverColor: '#e6e6e6'
  },
  reducers: {
    setMultipleLinksField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setImage(state, action) {
      state.files[0] = action.payload
    },
    delImage(state, action) {
      state.files[0] = action.payload
    },
    setMultipleLinks(state, action) {
      const { method, type, id, data } = action.payload
      switch (method) {
        case 'add':
          state.multipleLinks.push({ title: 'New link', link: '#' })
          return
        case 'remove':
          state.multipleLinks.splice(id, 1)
          return
        default:
          state.multipleLinks[id][type] = data
          return
      }
    },
    initializeMultipleLinks(state, action) {
      state.title = 'Teknikforce'
      state.files = []
      state.description = 'Generate fully customized QR Code'
      state.multipleLinks = [
        { title: 'Facebook', link: 'https://www.facebook.com/teknikforce/' },
        { title: 'Instagram', link: 'https://www.instagram.com/teknikforceofficial' },
        { title: 'Website', link: 'https://qroq.in' }
      ]
      state.fontFamily = 'Arial, sans-serif'
      state.cardColor = '#ffffff'
      state.titleColor = '#ffffff'
      state.titleBackgroundColor = '#1e2746'
      state.descriptionColor = '#000000'
      state.linkTitleColor = '#000000'
      state.linkButtonBackgroundColor = '#f2f2f2'
      state.linkButtonBorderColor = '#000000'
      state.linkButtonHoverColor = '#e6e6e6'
    }
  }
})

export const {
  setMultipleLinksField,
  setImage,
  delImage,
  setMultipleLinks,
  initializeMultipleLinks
} = linkSlice.actions
export default linkSlice.reducer